import { useView } from 'aurelia-framework';
import { computedFrom } from "aurelia-binding";
import { autoinject } from "aurelia-dependency-injection";
import { EnergyPowerLimitationTypeEnum, GhgVerificationRequestModel } from "../../../../../../../../models/ghgs/ghg.models";
import { BaseEnvironmentalVerificationTab } from "../base-environmental-verification-tab";

@autoinject
@useView('views/pages/modules/ghg/pages/request-an-environmental-verification/tabs/environmental-verification-eexi/environmental-verification-eexi.html')
export class EnvironmentalVerificationEexi extends BaseEnvironmentalVerificationTab {

    public eexiFiles: File[] = [];
    public eplShaPoLiFiles: File[] = [];
    public eeCertificateFiles: File[] = [];
    public today: string = new Date().toJSON();
    public vesselHasEexi: boolean;
    public isEnergySavingEquipmentInstalled: boolean = false;
    public numberOfEngines: { value: number }[] = [
        { value: null },
        { value: 0 },
        { value: 1 },
        { value: 2 },
        { value: 3 },
        { value: 4 },
        { value: 5 },
        { value: 6 },
        { value: 7 },
        { value: 8 },
        { value: 9 }
    ];

    public set hasEnergyPowerLimitation(val: boolean) {
        if (val) {
            this.ghgVerification.ghgVerificationEexi.energyPowerLimitationTypeId = EnergyPowerLimitationTypeEnum.EPL;
        }
    }

    @computedFrom('ghgVerification.ghgVerificationEexi.energyPowerLimitationTypeId')
    public get hasEnergyPowerLimitation(): boolean {
        return this.ghgVerification.ghgVerificationEexi.energyPowerLimitationTypeId == EnergyPowerLimitationTypeEnum.EPL;
    }

    @computedFrom('ghgVerification.ghgVerificationEexi.energyPowerLimitationTypeId')
    public get hasShaftPowerLimitation(): boolean {
        return this.ghgVerification.ghgVerificationEexi.energyPowerLimitationTypeId == EnergyPowerLimitationTypeEnum.ShaPoLi;
    }

    public set hasShaftPowerLimitation(val: boolean) {
        if (val) {
            this.ghgVerification.ghgVerificationEexi.energyPowerLimitationTypeId = EnergyPowerLimitationTypeEnum.ShaPoLi;
        }
    }

    @computedFrom('ghgVerification.ghgVerificationEexi.energyPowerLimitationTypeId')
    public get hasNoEnergyPowerLimitation(): boolean {
        return !this.ghgVerification.ghgVerificationEexi.energyPowerLimitationTypeId;
    }

    public set hasNoEnergyPowerLimitation(val: boolean) {
        if (val) {
            this.ghgVerification.ghgVerificationEexi.energyPowerLimitationTypeId = null;
        }
    }

    activate(ghgVerificationRequest: GhgVerificationRequestModel): void {
        super.activate(ghgVerificationRequest);
        this.eexiFiles = ghgVerificationRequest.eexiFiles;
        this.eplShaPoLiFiles = ghgVerificationRequest.eplShaPoLiFiles;
        this.eeCertificateFiles = ghgVerificationRequest.eeCertificateFiles;
        this.isEnergySavingEquipmentInstalled = ghgVerificationRequest.verifyOptions[2].isSelected;
    }

    toggleEnergySavingEquipmentTab() {
        this.model.toggleEnergySavingEquipment(this.isEnergySavingEquipmentInstalled);
    }
}